import { __rest, __assign } from 'tslib';
import React from 'react';
import { PrimaryTabListResponsive } from '../primary-tablist/Component.responsive.js';
import { SecondaryTabListResponsive } from '../secondary-tablist/Component.responsive.js';
import { Tabs } from './Component.js';
import '../../../../mq/esm';
import '../primary-tablist/Component.desktop.js';
import '../primary-tablist/Component.js';
import '@juggle/resize-observer';
import 'classnames';
import '../../../../keyboard-focusable/esm';
import '../../../../shared/esm';
import '../../hooks/use-tabs.js';
import 'react-merge-refs';
import '../scrollable-container/Component.js';
import 'compute-scroll-into-view';
import '../scroll-controls/Component.js';
import 'lodash/debounce';
import '../../../../icon-button/esm';
import '@alfalab/icons-glyph/ChevronLeftCompactSIcon';
import '@alfalab/icons-glyph/ChevronRightCompactSIcon';
import '../scroll-controls/utils.js';
import '../title/Component.js';
import '../../../../skeleton/esm';
import '../../index.module-ee015487.js';
import '../primary-tablist/Component.mobile.js';
import '../secondary-tablist/Component.desktop.js';
import '../../../../tag/esm/desktop';
import '../secondary-tablist/Component.js';
import '../../index.module-12c01850.js';
import '../secondary-tablist/Component.mobile.js';
import '../../../../tag/esm/mobile';

var views = {
    primary: PrimaryTabListResponsive,
    secondary: SecondaryTabListResponsive,
};
var TabsResponsive = function (_a) {
    var _b = _a.view, view = _b === void 0 ? 'primary' : _b, _c = _a.scrollable, scrollable = _c === void 0 ? false : _c, breakpoint = _a.breakpoint, client = _a.client, _d = _a.defaultMatchMediaValue, defaultMatchMediaValue = _d === void 0 ? client === undefined ? undefined : client === 'desktop' : _d, restProps = __rest(_a, ["view", "scrollable", "breakpoint", "client", "defaultMatchMediaValue"]);
    return (React.createElement(Tabs, __assign({ TabList: views[view], scrollable: scrollable, defaultMatchMediaValue: defaultMatchMediaValue, breakpoint: breakpoint, client: client }, restProps)));
};

export { TabsResponsive };
